import React from "react";
import { useParams } from "react-router-dom";

import DetailPage from "../components/DetailPage";
import { getReason } from "../data/whyChooseUs";

function WhyChooseUsDetail() {
  const { slug } = useParams();
  const reason = getReason(slug);

  return (
    <DetailPage
      item={reason}
      kind="WHY CHOOSE US"
      backTo="/"
      backLabel="Back to Home"
      notFoundTitle="Page not found"
      notFoundText="The page you're looking for doesn't exist."
      listTitle="What This Means in Practice"
      listItems={reason?.highlights}
      // This dataset has no useCases — the sidebar renders CTA-only.
    />
  );
}

export default WhyChooseUsDetail;
